module.exports = global["jQuery"] = require("-!/home/wevercbj/www5.weverducre.com/www/node_modules/expose-loader/index.js?$!./jquery.js");